export default {
  list: [],
  example: {}
}



// WEBPACK FOOTER //
// ./src/features/invoice_requests/store/state.js